const actions = {
  SET_STATE: "monitoringDisplayProfile/SET_STATE",
  DETAIL: "monitoringDisplayProfile/DETAIL",
};

export default actions;
